export {default} from './Header';



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Header/index.ts